var map = {
	"./image05.jpeg": 574,
	"./image1.jpeg": 832,
	"./image10.jpeg": 142,
	"./image2.jpeg": 79,
	"./image3.jpeg": 755,
	"./image4.jpeg": 922,
	"./image6.jpeg": 461,
	"./image7.jpeg": 528,
	"./image8.jpeg": 653,
	"./image9.jpeg": 736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;